// 资讯详情页，文章页面曝光
export const EVENT_ID_INFORMATION_DETAIL_PAGE_VIEW = 9053491955984384;
// 更多阅读列表栏每条资讯点击	
export const EVENT_ID_RECOMMEND_DETAIL_CLICK = 	10117900616361984;
// 今日推荐课程卡片点击
export const EVENT_ID_RECOMMEND_CARD_CLICK =  10117905654638592;